module.exports = __webpack_public_path__ + "static/media/tapan_animated.f9035f95.gif";